<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>{{ dialogFilter ? 'Buscador Recintos/Cultivos' : 'Buscador de Recintos (Parcelas/Invernaderos)' }}</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                        aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="Descripcion">Titular</label>
                                    <input formControlName="Titular" name="Titular" maxlength="100"
                                           class="form-control" id="Titular" type="text" value="">
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="Nif">NIF</label>
                                    <input formControlName="Nif" name="Nif" maxlength="17"
                                           class="form-control" id="Nif" type="text" value="">
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="inputTipoRecinto">Tipo de Recinto</label>
                                    <ng-select appendTo="body"
                                               [items]="tiposRecinto"
                                               [readonly]="!tiposRecinto || tiposRecinto.length === 0"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoRecinto"
                                               loadingText="Cargando..."
                                               [loading]="!tiposRecinto || tiposRecinto.length === 0"
                                               placeholder="-- Seleccione un Tipo --"
                                               [ngClass]="displayFieldCssNgSelect('IdTipoRecinto')"
                                               notFoundText="Tipo no encontrado"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="IdProvincia">Provincia</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="provincias"
                                               [readonly]="!provincias || provincias.length === 0"
                                               placeholder="-- Seleccione una Provincia --"
                                               [loading]="!provincias || provincias.length === 0"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                               (change)="onSelectProvincia($event)"
                                               notFoundText="Provincia no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="IdMunicipio">Municipio</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="municipios"
                                               [readonly]="!municipios || form.value.IdProvincia === null"
                                               placeholder="-- Seleccione un Municipio --"
                                               [loading]="!municipios && form.value.IdProvincia !== null"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdMunicipio"
                                               [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                               notFoundText="Municipio no encontrado"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="Agregado">Agregado</label>
                                    <input formControlName="Agregado" name="Agregado" maxlength="5"
                                           class="form-control" id="Agregado" type="text" value="">
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="Zona">Zona</label>
                                    <input formControlName="Zona" name="Zona" maxlength="5"
                                           class="form-control" id="Zona" type="text" value="">
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="Poligono">Polígono</label>
                                    <input formControlName="Poligono" name="Poligono" maxlength="5"
                                           class="form-control" id="Poligono" type="text" value="">
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="Parcela">Parcela</label>
                                    <input formControlName="Parcela" name="Parcela" maxlength="10"
                                           class="form-control" id="Parcela" type="text" value="">
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="Recinto">Recinto</label>
                                    <input formControlName="Recinto" name="Recinto" maxlength="10"
                                           class="form-control" id="Recinto" type="text" value="">
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="EsCompleta">Parcela completa</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="EsCompleta"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-xl-2 col-md-3">
                                    <label class="col-form-label" for="inpAutorizados">Cultivos autorizados</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Autorizado"
                                                    unselectable="true">
                                    </p-selectButton>
                                    <div class="invalid-feedback tip d-block">
                                        <label>Recintos con TODOS los Cultivos autorizados</label>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                            [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                                <i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                            [disabled]="formIsUntouched()"
                                            title="Limpia los filtros" (click)="onResetForm($event)">
                                                <i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
